import { Box, CircularProgress, Typography, useTheme } from '@mui/material'

const SearchLoading = ({isDarkMode: isDarkModeProp}) => {
    const theme = useTheme();
    const isDarkMode = isDarkModeProp !== undefined ? isDarkModeProp : theme.palette.mode === 'dark';

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: { xs: 200, sm: 250 },
            p: { xs: 2, sm: 3 },
            background: isDarkMode 
                ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)' 
                : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: 3,
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }}>
            <Box sx={{
                position: 'relative',
                display: 'inline-flex',
                mb: 2
            }}>
                <CircularProgress
                    size={60}
                    thickness={4}
                    sx={{
                        color: isDarkMode ? '#64B5F6' : '#0364ff',
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                        }
                    }}
                />
            </Box>
            <Typography sx={{
                color: isDarkMode ? '#e0e0e0' : '#2d3748',
                fontWeight: 600,
                fontSize: { xs: 15, sm: 16 },
                textAlign: 'center'
            }}>
                Buscando resultados...
            </Typography>
            <Typography sx={{
                color: isDarkMode ? '#a0a0a0' : '#718096',
                fontSize: { xs: 12, sm: 13 },
                textAlign: 'center',
                mt: 0.5
            }}>
                Por favor espera un momento
            </Typography>
        </Box>
    )
}

export default SearchLoading
